<etn-action [action]="action()"></etn-action>
